import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";
import $ from "jquery";
import * as utils from "../../../utils.js";

export default class FormTipoFormacion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titulacion: null,
    };

    this.TipoFormacionPost = this.TipoFormacionPost.bind(this);
    this.TipoFormacionPut = this.TipoFormacionPut.bind(this);
    this.selectStudyLevels = this.selectStudyLevels.bind(this);
    this.selectStudyFields = this.selectStudyFields.bind(this);
    this.getDefaultValue = this.getDefaultValue.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.setState({
      titulacion: true,
    });
    if (this.props.id !== undefined) {
      if (this.props.DatosUsuario.datosTipoFormacion.estudios[this.props.id].studyLevelId) {
        this.setState({
          titulacion: true,
        });
      } else if (this.props.DatosUsuario.datosTipoFormacion.estudios[this.props.id].hours) {
        this.setState({
          titulacion: false,
        });
      }
    }
  }

  TipoFormacionPost(event) {
    event.preventDefault();
    let $this = $(this);
    let myform = document.getElementById("MyForm");
    let form = new FormData(myform);

    let settings = {
      url: process.env.REACT_APP_API_URL + "/usuarios/" + $this[0].props.DatosUsuario.id + "/estudios",
      method: "POST",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };

    $.ajax(settings)
      .done(function (response) {
        $this[0].props.setAlert("", "Se han añadido los datos correctamente", "success");
        response = JSON.parse(response);
        $this[0].props.setTipoFormacion(response);
      })
      .fail($this[0].props.ErrorHandling);
  }

  TipoFormacionPut(event) {
    event.preventDefault();
    let $this = $(this);
    let myform = document.getElementById("MyForm");
    let form = new FormData(myform);

    let settings = {
      url: process.env.REACT_APP_API_URL + "/usuarios/" + $this[0].props.DatosUsuario.id + "/estudios/" + $this[0].props.DatosUsuario.datosTipoFormacion.estudios[this.props.id].id,
      method: "PUT",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };
    $.ajax(settings)
      .done(function (response) {
        $this[0].props.setAlert("", "Se han editado los datos correctamente", "success");
        response = JSON.parse(response);
        $this[0].props.putTipoFormacion(response, $this[0].props.id);
      })
      .fail($this[0].props.ErrorHandling);
  }

  selectStudyLevels() {
    let studylevels = [];
    if (this.props.DatosUsuario.datosTipoFormacion) {
      for (let i = 0; i < this.props.DatosUsuario.datosTipoFormacion.nivelEstudios.length; i++) {
        studylevels.push(<option value={parseInt(this.props.DatosUsuario.datosTipoFormacion.nivelEstudios[i].id)}>{this.props.DatosUsuario.datosTipoFormacion.nivelEstudios[i].type}</option>);
      }
    }
    return studylevels;
  }

  selectStudyFields() {
    let studyfields = [];
    if (this.props.DatosUsuario.datosTipoFormacion) {
      for (let i = 0; i < this.props.DatosUsuario.datosTipoFormacion.campoEstudios.length; i++) {
        studyfields.push(<option value={parseInt(this.props.DatosUsuario.datosTipoFormacion.campoEstudios[i].id)}>{this.props.DatosUsuario.datosTipoFormacion.campoEstudios[i].type}</option>);
      }
    }
    return studyfields;
  }

  getDefaultValue(field) {
    let defaultvalue = null;
    if (this.props.id !== undefined) {
      defaultvalue = this.props.DatosUsuario.datosTipoFormacion.estudios[this.props.id][field];
    }
    return defaultvalue;
  }

  handleChange(event) {
    if (event.target.name === "titulacion") {
      this.setState({
        titulacion: !this.state.titulacion,
      });
    }
  }

  render() {
    // Para obtener la fecha actual para la restriccion html
    let today = utils.calculateDate();

    const titulacion = this.state.titulacion ? (
      <Form.Control required autoComplete="nope" as="select" name="studyLevelId" defaultValue={this.getDefaultValue("studyLevelId")}>
        {this.selectStudyLevels()}
      </Form.Control>
    ) : (
      <Form.Group>
        <Form.Label>Horas *</Form.Label>
        <Form.Control required autoComplete="nope" type="number" name="hours" defaultValue={this.getDefaultValue("hours")}></Form.Control>
      </Form.Group>
    );

    const checkedDefault =
      this.state.titulacion !== null ? (
        <Form.Group>
          <Form.Label>Titulación *</Form.Label>
          <Form.Check type="radio" label="Sí" name="titulacion" defaultChecked={this.props.id !== undefined ? this.state.titulacion : 1} onChange={this.handleChange}></Form.Check>
          <Form.Check className="mb-3" type="radio" label="No" name="titulacion" defaultChecked={this.props.id !== undefined ? !this.state.titulacion : 0} onChange={this.handleChange}></Form.Check>
          {titulacion}
        </Form.Group>
      ) : null;

    return (
      <Form className=" p-4" onSubmit={this.props.id !== undefined ? this.TipoFormacionPut : this.TipoFormacionPost} autoComplete="off" id="MyForm">
        <Form.Group>
          <Form.Row>
            <small className="mb-3">
              Los campos con un <b>*</b> deben de ser rellenados.
            </small>
          </Form.Row>
          <Form.Label>Campo de Estudio *</Form.Label>
          <Form.Control required autoComplete="nope" as="select" name="studyFieldId" defaultValue={this.getDefaultValue("studyFieldId")}>
            {this.selectStudyFields()}
          </Form.Control>
        </Form.Group>
        <Form.Group>
          <Form.Label>Estudio Realizado *</Form.Label>
          <Form.Control required maxLength="80" autoComplete="nope" type="text" name="name" defaultValue={this.getDefaultValue("name")} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Centro *</Form.Label>
          <Form.Control required maxLength="80" autoComplete="nope" type="text" name="center" defaultValue={this.getDefaultValue("center")} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Fecha de Término *</Form.Label>
          <Form.Control required max={today} autoComplete="nope" type="date" name="date" defaultValue={this.getDefaultValue("date")} />
        </Form.Group>
        {checkedDefault}
        <Form.Group>
          <Button
            type="submit"
            variant="outline-success"
            className="btn btn-block mt-5"
            //onClick={this.props.handleButtonShow} TODO cuando se le da a guardar no se cierra el modal
            name="Cerrar"
          >
            Guardar
          </Button>
        </Form.Group>
      </Form>
    );
  }
}
